import { deviceUtils } from '../device-utils';
import {
  validSettingData,
  validSettingKey
} from 'kaistore-post-messenger/lib/constants';
import { MessageSender } from 'web-message-helper';
import { RequestSettingCommand } from 'kaistore-post-messenger/src/commands';

class RichContentHelper {
  constructor() {
    this._enable = false;
    this._settingValue = null;
  }

  set settingValue(value) {
    this._settingValue = value;
  }

  _checkEnable(settingValue) {
    let enable = false;
    switch (settingValue) {
      case 'wifi-only':
        enable = deviceUtils.information.connection.type === 'wifi';
        break;
      case 'data-enable':
        enable = true;
        break;
      default:
        enable = false;
    }
    return enable;
  }

  get enable() {
    if (this._settingValue === null) {
      const key = validSettingKey.RICH_CONTENT;
      MessageSender.send(
        new RequestSettingCommand({
          detail: {
            key: key
          }
        }),
        (success, result) => {
          this.settingValue =
            success && result.value
              ? result.value
              : validSettingData[key].default;
          return this._checkEnable(this._settingValue);
        }
      );
    } else {
      return this._checkEnable(this._settingValue);
    }
  }
}

export default (RichContentHelper = new RichContentHelper());



/** WEBPACK FOOTER **
 ** ./src/helper/richcontent-helper.js
 **/